import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setPageTitle } from '../../redux/slice/pageTitleSlice'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'
import MainCategoryList from './MainCategory/MainCategoryList'
import SubCategoryList from './SubCategory/SubCategoryList'

const ManageCategory = () => {
  const [activeToggle, setActiveToggle] = useState('maincategory')
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setPageTitle('Manage Category'))
  }, [])

  const { pageAccess } = useSelector((state) => state.user)

  return checkPageAccess(pageAccess, allPages?.category, allCrudNames?.read) ? (
    <>
      <div className='card overflow-hidden'>
        <div className='card-body p-0'>
          <div className='nav-tabs-horizontal nav nav-tabs'>
            <Link
              onClick={() => setActiveToggle('maincategory')}
              data-toggle='tab'
              className={`nav-link fw-semibold ${
                activeToggle === 'maincategory' ? 'active show' : ''
              }`}
            >
              <span className='nav-span'>
                Main Category
                <hr />
              </span>
            </Link>
            <Link
              onClick={() => setActiveToggle('subcategory')}
              data-toggle='tab'
              className={`nav-link fw-semibold ${
                activeToggle === 'subcategory' ? 'active show' : ''
              }`}
            >
              <span className='nav-span'>
                Sub Category
                <hr />
              </span>
            </Link>
          </div>

          <div className='tab-content p-3'>
            <div
              id='maincategory'
              className={`tab-pane fade ${
                activeToggle === 'maincategory' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'maincategory' && <MainCategoryList />}
            </div>

            <div
              id='subcategory'
              className={`tab-pane fade ${
                activeToggle === 'subcategory' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'subcategory' && <SubCategoryList />}
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <NotFound />
  )
}

export default ManageCategory
